import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@deporvillage/picture-component';
import Stars, { StarSizes } from "@deporvillage/stars-component";
import { formatDate, I18nContext } from "@deporvillage/utils-library-component";
import { Config } from '@deporvillage/utils-library-component';

import styles from './ReviewBubble.module.scss';

const ReviewBubble = ({ arrow, review }) => {

    const { lang } = React.useContext(Config);
    const { translate } = React.useContext(I18nContext);

    const {
        title,
        description,
        value,
        nickname,
        createdAt,
        product,
    } = review;

    return (
        <div className={`${styles['review-bubble-component']} ${arrow ? styles.arrows : ``}`}>
            <div className={styles['review-header']}>
                {
                    product?.image ? (
                        <Picture
                            width={45}
                            name={product?.title}
                            src={`product/${product?.image}`}
                            className={styles['review-image']}
                            lazy
                        />
                    ) : null
                }
                <div className={styles['review-title']}>
                    {
                        title ? <strong>{title}</strong> : null
                    }
                    <Stars rate={value} size={StarSizes.small} />
                </div>
            </div>
            <div className={styles['review-body']} dangerouslySetInnerHTML={{ __html: description }} />
            <div
                className={styles['review-author']}
                dangerouslySetInnerHTML={{
                    __html: translate('generic.review.author', {
                        username: nickname || translate('generic.review.user_anonymous'),
                        date: formatDate(createdAt, lang),
                    }),
                }}
            />
        </div>
    );
};

ReviewBubble.propTypes = {
    arrow: PropTypes.bool,
    review: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.any,
        value: PropTypes.number,
        nickname: PropTypes.string,
        createdAt: PropTypes.string,
        product: PropTypes.shape({
            title: PropTypes.string,
            image: PropTypes.string,
        }),
    }),
};

export default ReviewBubble;
